<template>
    <div class="navbar">
      <div class="left-logo">
        <!-- <a :href="'https://'+linkData"> -->
        <span><img src="./../../assets/logo-old.png" @click="jumpToIndex"  style="cursor: pointer"/></span>
        <!-- </a> -->
      </div>
      <div class="right-menu">
      <!--
        <el-input v-model="searchVal" prefix-icon="el-icon-search" placeholder="请输入关键字"></el-input>
        <ul class="menuList">
          <li>门户</li>
          <li class="active">
            <a href="https://project.itheima.net" target="_blank">项目库</a>
          </li>
        </ul>
        -->
        <!--<span class="rightMenu"><img src="./../../assets/logomall.jpg" />
        
        </span>-->
      </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'layoutNavBar',
  components: {
  },
  computed: {
    ...mapGetters(['sidebar', 'name', 'avatar'])
  },
  data() {
    return {
      searchVal: '',
      timeout: null,
      showSearchInput: false,
      restaurants: [],
      linkData:""
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('toggleSideBar')
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // In order to re-instantiate the vue-router object to avoid bugs
      })
    },
    handleBtnSearch() {
      this.showSearchInput = !this.showSearchInput
      this.$nextTick(() => {
        this.$refs['searchInput'].focus()
      })
    },
    querySearchAsync(queryString, cb) {
      var restaurants = this.restaurants
      var results = queryString
        ? restaurants.filter(this.createStateFilter(queryString))
        : restaurants

      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        cb(results)
      }, 1000 * Math.random())
    },
    createStateFilter(queryString) {
      return state => {
        return (
          state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        )
      }
    },
    handleSelect(item) {
      this.searchVal = ''
      this.showSearchInput = false
      this.$message({
        message: `选取了 ${item.value}`,
        type: 'success'
      })
    },
    jumpToIndex() {
      sessionStorage.setItem("subjectID","1");
      this.$router.push("/");
    },
  },
  mounted() {
  },
  created() { 
    var data=[]
    data=window.location.href.split('/')
    for(var i=0;i<data.length;i++){
      if(data[i]!==""){
        if(data[i]==="project-dev.itheima.net"){
          this.linkData=data[i]
        }else if(data[i]==="pip.itcast.cn"){
          this.linkData=data[i]
        }
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
.hideSidebar .navbar {
  left: 36px;
}
.navbar .item .el-input__inner {
  border: 0px;
  border-bottom: 1px solid #dcdfe6;
  border-radius: 0px;
}
.Homelogo {
  background: #1493fa;
  height: 56px;
  padding: 15px 0 0;
  text-align: center;
  span {
    background: url(./../../assets/logo.png) no-repeat 50%;
    display: block;
    height: 28px;
  }
}
</style>

<style rel="stylesheet/scss" lang="scss">
.hideSidebar .navbar {
  left: 36px;
}
.navbar {
  position: fixed;
  z-index: 99;
  width: 100%;
  
  border-radius: 0px !important;
  background: #fff;
  top:0px;
  left: 0;
  color:#333;
  font-size:16px;
  box-shadow: 0px 10px 10px -10px rgba(0,0,0,0.10);
  .hamburger-container {
    
    float: left;
    padding: 0 10px;
  }
  .breadcrumb-container {
    float: left;
  }
  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }
  .left-logo{
    float:left;
    padding:3px 0 0 35px;
    font-size:16px;
    font-family:"Microsoft YaHei",微软雅黑,"MicrosoftJhengHei",华文细黑,STHeiti,MingLiu;
    color:#333;
    span{
      margin-right:4px;
    img{
      height: 54px;
      vertical-align: middle;
    }
  }
  }
  .right-menu {
    text-align:left;
    // float: left;
   // position: absolute;
    // right: 0px;
    margin-left:256px;
    height: 58px;
    line-height:58px;
    .rightMenu{
      padding-right:45px;
    }
    .el-input{
      display:inline-block;
      width:auto;
    }
    .el-input--medium{
       .el-input__inner{
         height:28px;
         border-radius: 5px;
         background:#f4f4f4;
         border: 0 none;
         width:320px;
         margin-right:55px;
         font-size: 14px;
       }
    }
    span{
      &.el-input__prefix{
        padding:0;
      }
    }
  }
}
.el-menu{
  position:fixed !important;
}
</style>
